import { Component } from 'react';
import {
  createMoreInstructionMarkup,
  questionComponentPropTypes,
} from './helpers';
import Immutable from 'immutable';
import MarkingResponse from './MarkingResponse';
import { Button } from 'react-bootstrap';

class SelfMarkQuestion extends Component {
  componentDidMount() {
    this.setResponseToReview();
  }

  // Set the response we want to mark
  setResponseToReview = () => {
    if (this.props.quizAttemptToReview) {
      // This is not reflected in the first render
      this.props.onResponseChange(
        this.props.response.set(
          'reviewed_question_attempt',
          this.props.quizAttemptToReview.get('id')
        )
      );
    }
  };

  handleResponseChange = (e) => {
    this.props.onResponseChange(
      this.props.response.set('answer', e.target.value)
    );
  };

  disabled = () => {
    return !this.props.response.get('answer') || this.props.isSaving;
  };

  handleKeyUp = (e) => {
    if (e.key === 'Enter' && !this.disabled()) {
      this.props.onSaveClick();
    }
  };

  render = () => {
    const { quizAttemptToReview, question, response, onSaveClick } = this.props;

    return (
      <div className="question integer-question">
        <div className="left">
          <span>
            <MarkingResponse
              response={response}
              label={question.get('marking_prompt')}
              marksAvailable={question.get('indicated_maximum_marks')}
              onChange={this.handleResponseChange}
              onKeyUp={this.handleKeyUp}
            />
            <Button onClick={onSaveClick} disabled={this.disabled()}>
              Save &amp; Continue
            </Button>
          </span>
          <p>
            <b>Your response</b>
          </p>
          <span className="response-text">
            {quizAttemptToReview ? (
              <p>{quizAttemptToReview.get('answer')}</p>
            ) : (
              '-'
            )}
          </span>
        </div>
        <div className="right">
          <span
            className="rubric"
            dangerouslySetInnerHTML={createMoreInstructionMarkup(question)}
          />
        </div>
      </div>
    );
  };
}

SelfMarkQuestion.propTypes = questionComponentPropTypes;
SelfMarkQuestion.defaultProps = {
  response: Immutable.Map(),
};

export default SelfMarkQuestion;
